<template>
  <div class="designerIndex">
    <div class="banner">
      <img
        src="../../../assets/serve/designer/bg.png"
        alt=""
        srcset=""
        ref="kv"
      />
      <div class="content">
        <div class="title">设计之家</div>
        <div class="line"></div>
        <div class="descr">HOME OF DESIGN</div>
      </div>
    </div>
    <div class="container" ref="container">
      <div class="designerCase">
        <div class="title">设计案例</div>
        <div class="case-content">
          <div
            class="caseItem"
            v-for="(caseItem, index) in caseList"
            :key="index"
            @click="showDailog(caseItem)"
          >
            <img class="title-pic" :src="caseItem.title_pic" />
            <div class="info">
              <div class="name">{{ caseItem.creation_name }}</div>
              <div class="author">
                <div class="headerPic">
                  <img
                    v-if="caseItem.headpic"
                    :src="caseItem.headpic"
                    alt=""
                    srcset=""
                  />
                </div>
                <div class="author-name">{{ caseItem.nick }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="designerCase">
        <div class="title">实景案例</div>
        <div class="case-content">
          <div
            class="caseItem"
            v-for="(sceneItem, index) in sceneList"
            :key="index"
            @click="showDailog(sceneItem)"
          >
            <img class="title-pic" :src="sceneItem.title_pic" />
            <div class="info">
              <div class="name">{{ sceneItem.creation_name }}</div>
              <div class="author">
                <div class="headerPic">
                  <img
                    v-if="sceneItem.headpic"
                    :src="sceneItem.headpic"
                    alt=""
                    srcset=""
                  />
                </div>
                <div class="author-name">{{ sceneItem.nick }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="kv">
      <Swiper1 v-if="kvList.length > 0" :data="kvList"></Swiper1>
    </div>
    <DesignerInfo v-if="showPopup" :show.sync="showPopup" :info="dialogData" @close="showPopup = false"></DesignerInfo>
    <DesignerSignup v-if="showDesignSignup" :show="showDesignSignup" :userInfo="userInfo" @close="showDesignSignup = false" @success="showSuccess = true"></DesignerSignup>
    <SignupSuccess v-if="showSuccess" :show="showSuccess" showbtn @close="showSuccess = false"></SignupSuccess>
  </div>
</template>

<script>
import Swiper1 from "@/components/swiper1";
import { searchCreation } from "@/api/case.js";
import DesignerSignup from "@/components/designerSignup.vue"
import DesignerInfo from "@/components/designerInfo.vue"
import SignupSuccess from '@/components/signupSuccess.vue'
import { doAdvertiseGeneralList } from "@/api/case.js";
export default {
  name: "designerIndex",
  components: {
    Swiper1,
    DesignerSignup,
    DesignerInfo,
    SignupSuccess
  },
  watch: {},
  props: {
    userInfo: {}
  },
  data() {
    return {
      kvList: [
        // {
        //   img: require("@/assets/serve/index/serveKV.jpg"),
        //   url: 'https://mp.weixin.qq.com/s/s5cmsTjMbb-mcvXngw78uQ',
        //   // url: `${this.$Path}/#/serve/activity`,
        //   target: '_blank'
        //   // target: '_top'
        // },
        // {
        //   img: require('@/assets/serve/3200_1347.png'),
        //   url: 'https://mp.weixin.qq.com/s?__biz=MzkyMDA1MzAzOQ==&mid=2247495663&idx=1&sn=6836062717dcb4dadb6fe6510bc5e5e7&chksm=c19a1baff6ed92b9fc07b7a71a05fa799acd33d8c9a2b89a7ae3bfb4cf48c3e2be47e95362da&token=1941848510&lang=zh_CN#rd',
        //   target: '_blank'
        // }
      ],
      caseList: [],
      sceneList: [],
      dialogData: {},
      showPopup: false,
      oldHeight: 0,
      showDesignSignup: false,
      showSuccess: false
    };
  },
  async created() {
    await this.indexCase();
    await this.sceneCase();
    await this.getImageList()
  },
  mounted() {
  },
  methods: {
    // 设计案例列表
    indexCase() {
      searchCreation({
        user_type: 1,
        chk_type: 1,
        pageNum: 1,
        pageSize: 4,
      }).then((res) => {
        if (res.result == 1) {
          this.caseList = res.data;
        } else {
          this.$message(res.msg);
        }
      });
    },

    // 实景案例列表
    sceneCase() {
      searchCreation({
        user_type: 3,
        chk_type: 1,
        pageNum: 1,
        pageSize: 4,
      }).then((res) => {
        if (res.result == 1) {
          this.sceneList = res.data;
        } else {
          this.$message(res.msg);
        }
      });
    },
    showDailog(data) {
      this.showPopup = true;
      this.dialogData = data;
    },
    gosignup() {
      if ('id' in this.userInfo) {
        this.showDesignSignup = true
      } else {
        this.$emit('needLogin', true)
      }
    },
    getImageList() {
      doAdvertiseGeneralList({
        adv_sign: 0,
        adv_type: '208',
        adv_state: '-1',
        keyword: '',
        pageNum: 1,
        pageSize: 10
      }).then((res) => {
        if (res.result == 1) {
          this.kvList = res.dataList
        } else {
          this.$message(res.msg)
        }
      });
    }
  },
};
</script>

<style lang="less" scoped>
.designerIndex {
  max-width: 1920px;
  margin: 0 auto;
  overflow: hidden;
  position: relative;
  .banner {
    position: relative;
    img {
      width: 100%;
    }
  }
  .content {
    width: 100%;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    flex-direction: column;
    align-content: center;
    text-align: center;
    .title {
      font-size: 48px;
      font-weight: 400;
      color: #ffffff;
      letter-spacing: 2px;
      margin-bottom: 29px;
    }
    .line {
      width: 137px;
      height: 6px;
      background: #4e8b46;
      margin: 0 auto;
    }
    .descr {
      letter-spacing: 8px;
      font-size: 48px;
      font-weight: 400;
      color: #ffffff;
      margin-top: 35px;
    }
    .signup-btn {
      width: 262px;
      height: 80px;
      margin: 85px auto 32px auto;
      cursor: pointer;
    }
    .descr-title {
      font-size: 24px;
      font-weight: 400;
      color: #ffffff;
      letter-spacing: 2px;
    }
  }
  .container {
    padding: 27.5px 220px 50px 240px;
    .designerCase {
      display: flex;
      flex-direction: column;
      .title {
        width: 216px;
        height: 55px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 25px;
        font-weight: 400;
        color: #ffffff;
        margin-bottom: 21px;
        background: url('../../../assets/serve/designer/titlebg.png')no-repeat center center;
        background-size: 100% 100%;
      }
      .case-content {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        flex-wrap: wrap;
        .caseItem {
          width: 340px;
          margin-bottom: 42px;
          margin-right: 27.5px;
          cursor: pointer;
          -webkit-user-select: none;
          .title-pic {
            width: 340px;
            height: 255px;
            object-fit: cover;
            border-radius: 10px;
            vertical-align: top;
          }
          .info {
            width: 100%;
            margin-top: 16.5px;
            .name {
              text-align: left;
              font-size: 25px;
              font-family: FZLanTingHeiS-R-GB;
              font-weight: 400;
              color: #000000;
              margin-bottom: 13px;
            }
            .author {
              display: flex;
              flex-direction: row;
              justify-content: flex-start;
              align-items: center;
              .headerPic {
                width: 25px;
                height: 25px;
                border-radius: 50%;
                overflow: hidden;
                background: #000;
                img {
                  width: 100%;
                  vertical-align: top;
                }
              }
              .author-name {
                margin-left: 6.5px;
                font-size: 19px;
                font-family: FZLanTingHeiS-R-GB;
                font-weight: 400;
                color: #595858;
              }
            }
          }
          &:nth-of-type(4n) {
            margin-right: 0;
          }
        }
      }
    }
  }
  .kv {
    margin: 38.5px auto;
    // overflow: hidden;
  }
}
</style>